module.exports = __webpack_public_path__ + "media/images/diy/bronx_ny_uplighting-b70a4afeb00a55b5097c1577ad8d8759.png";